import { render, staticRenderFns } from "./SalariePrintFinalTax.vue?vue&type=template&id=95a5b74a&scoped=true"
import script from "./SalariePrintFinalTax.vue?vue&type=script&lang=js"
export * from "./SalariePrintFinalTax.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintFinalTax.vue?vue&type=style&index=0&id=95a5b74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a5b74a",
  null
  
)

export default component.exports